<script setup lang="ts">
import type { TutorLegalFile } from '../../model/legal/interfaces'

import { faFileLines, faTrashCan } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'
import { BtnIcon } from '@shared/ui/buttons'

defineOptions({
  name: 'TutorLegalFileItem',
})

defineProps<{
  file: TutorLegalFile
}>()

const emit = defineEmits<{
  remove: []
}>()

const handleRemove = (): void => emit('remove')
</script>

<template>
  <div class="tutor-legal-file">
    <div class="tutor-legal-file__info">
      <AppIcon
        :icon="faFileLines"
        size="small"
        color="slate-500"
      />
      <a
        :href="file.url"
        target="_blank"
        class="tutor-legal-file__name"
      >
        {{ file.name }}
      </a>
      <AppText
        name="body2"
        color="slate-400"
      >
        {{ file.size }}
      </AppText>
    </div>
    <BtnIcon
      :icon="faTrashCan"
      view="transparent"
      size="small"
      @click="handleRemove"
    />
  </div>
</template>

<style lang="scss" scoped src="./TutorLegalFileItem.scss" />
